import {CompanyDepartmentRes, CompanyDetailsMinRes} from "./company.contract";
import {Type} from 'class-transformer';
import moment from "moment";
import {UserLicensesRes} from './license.contract';
import {Salutation} from "../../../enums";
import {PermissionRes} from './account.contracts';
import {FileUploadRes} from '@yasc/yasc-material-components';
import {ProjectTrackerRes} from '../crm';
import {UsedTimeRes} from '../resource-manager/used-time';
import {AppointmentRes} from '../resource-manager';
import {RoleRes} from './role.contract';

export class UserDetailsMinRes {
    id!: number;
    salutation!: Salutation;
    title!: string;
    userName!: string;
    email!: string;
    givenName!: string;
    lastName!: string;
    emailConfirmed!: boolean;
    weeklyWorkHours!: number
    birthDate?: any;

    @Type(() => CompanyDepartmentRes)
    public department: CompanyDepartmentRes | null = null;

    @Type(() => FileUploadRes)
    public profileImage?: FileUploadRes;

    @Type(() => FileUploadRes)
    public signature: FileUploadRes | undefined;

    get fullName() {
        return (this.title ? this.title + ' ' : '') + this.givenName + ' ' + this.lastName;
    }
}

export class UserUpdateReq {
    public id!: number;
    public title?: string;
    public email?: string;
    public givenName?: string;
    public lastName?: string;
    public roles?: number[];
    public salutation?: number;
    public birthDate?: any;
    public departmentId?: string;
    public phone?: string;
    public password?: string;
    public profileImageId?: string;
    public signatureId?: string;
    public isVisible?: boolean;
    public birthCountry?: string;

    get username() {
        return `${this.givenName} ${this.lastName}`
    }

    constructor(user?: UserDetailsRes) {
        if (user != null) {
            this.id = user.id;
            this.phone = user.phone;
            this.title = user.title;
            this.salutation = user.salutation;
            this.birthDate = user.birthDate;
            this.email = user.email;
            this.givenName = user.givenName;
            this.lastName = user.lastName;
            this.departmentId = user.department?.guid;
            this.roles = user.roles.map(x => x.id);
            this.signatureId = user.signature?.id;
        }
    }

    static compare(a: RoleRes, b: RoleRes): boolean {
        return a.id == b.id;
    }
}

export class UserDetailsRes {
    public id!: number;
    public title!: string;
    public userName!: string;
    public email!: string;
    public givenName!: string;
    public lastName!: string;
    public salutation!: number;
    public emailConfirmed!: boolean;
    public integrationCount: number = 0;
    public securityRecommendationCount: number = 0;
    public isProfileComplete: boolean = false;

    @Type(() => CompanyDepartmentRes)
    public department: CompanyDepartmentRes | null = null;

    @Type(() => FileUploadRes)
    public profileImage?: FileUploadRes;

    @Type(() => FileUploadRes)
    public signature: FileUploadRes | undefined;


    public birthDate!: any;
    public birthCountry!: string;
    public phone?: string;
    public isActive!: boolean;
    public isVisible!: boolean;
    private _lastPasswordUpdate: any;
    private _created: any;
    private _lockoutEnd?: any;
    public weeklyWorkHours!: number

    @Type(() => RoleRes)
    public roles: RoleRes[] = [];

    @Type(() => PermissionRes)
    public permissions: PermissionRes[] = [];

    //Todo request for just licences of user
    @Type(() => UserLicensesRes)
    public assignedLicences: UserLicensesRes[] = []

    @Type(() => CompanyDetailsMinRes)
    public company!: CompanyDetailsMinRes;

    @Type(() => ProjectTrackerRes)
    public projectList: ProjectTrackerRes[] = []

    @Type(() => UsedTimeRes)
    public usedTime: UsedTimeRes[] = []

    @Type(() => AppointmentRes)
    public appointments:AppointmentRes[] = []


    get lastPasswordUpdate(): any {
        return this._lastPasswordUpdate;
    }

    set lastPasswordUpdate(value: any) {
        this._lastPasswordUpdate = moment(value);
    }

    get created(): any {
        return this._created;
    }

    set created(value: any) {
        this._created = value;
    }

    get lockoutEnd(): any | undefined {
        return this._lockoutEnd;
    }

    set lockoutEnd(value: any | undefined) {
        this._lockoutEnd = value;
    }

    get fullName() {
        return (this.title ? this.title + ' ' : '') + this.givenName + ' ' + this.lastName;
    }

}
